import { render } from "./NavDesktop.vue?vue&type=template&id=3d1c7f82&scoped=true"
import script from "./NavDesktop.vue?vue&type=script&lang=js"
export * from "./NavDesktop.vue?vue&type=script&lang=js"

import "./NavDesktop.vue?vue&type=style&index=0&id=3d1c7f82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d1c7f82"

export default script